var React = require('react');

function Icons8Facebook (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M7 5c-1.094 0-2 .906-2 2v18c0 1.094.906 2 2 2h18c1.094 0 2-.906 2-2V7c0-1.094-.906-2-2-2zm0 2h18v18h-5.187v-6.75h2.594l.375-3h-2.969v-1.937c0-.875.215-1.469 1.469-1.469h1.625V9.125c-.277-.035-1.238-.094-2.344-.094-2.305 0-3.875 1.387-3.875 3.969v2.25h-2.625v3h2.625V25H7z"}));
}

Icons8Facebook.defaultProps = {"viewBox":"0 0 32 32","fill":"#000000","xmlnsV":"https://vecta.io/nano"};

module.exports = Icons8Facebook;

Icons8Facebook.default = Icons8Facebook;
